export const GET_MATRICULAS_REQUEST = 'GET_MATRICULAS_REQUEST'
export const GET_MATRICULA = 'GET_MATRICULA'
export const GET_MATRICULAS = 'GET_MATRICULAS'
export const GET_DATOS_MATRICULAS = 'GET_DATOS_MATRICULAS'
export const GET_STUDENTS_MATRICULA = 'GET_STUDENTS_MATRICULA'
export const ADD_MATRICULA = 'ADD_MATRICULA'
export const DELETE_MATRICULA = 'DELETE_MATRICULA'
export const EDIT_MATRICULA = 'EDIT_MATRICULA'
export const MATRICULA_FAIL = 'MATRICULA_FAIL'
export const GET_MATRICULA_BY_USER_ID = 'GET_MATRICULA_BY_USER_ID'
